import { ProfileService } from '@shared/core';
import { Injectable } from '@angular/core';
import { PROFILE, PROFILE_EDIT, SESSION } from '../actions/index';
import {
	ProfileHydrateAction,
	ProfileUpdateAction,
	ProfileUpdateFailureAction,
	ProfileUpdateSuccessAction
} from '../actions/profile-actions';
import { ProfileEditClickSubmitAction } from '../actions/profile-edit-actions';
import { SessionInitAction } from '../actions/session-actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, from, iif, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { isServiceEnabled } from '../services-config';

@Injectable()
export class ProfileEffects {
	@Effect({ dispatch: true })
	profileEditClickSubmit$ = this.actions$.pipe(
		ofType<ProfileEditClickSubmitAction>(PROFILE_EDIT.CLICK_SUBMIT),
		map(action => new ProfileUpdateAction(action.payload, action.correlationId))
	);
	@Effect({ dispatch: true })
	profileUpdate$ = this.actions$.pipe(
		ofType<ProfileUpdateAction>(PROFILE.UPDATE),
		switchMap(action =>
			from(this.profile.updateProfile(action.payload)).pipe(
				map(d => new ProfileUpdateSuccessAction(d, action.correlationId)),
				catchError(error => of(new ProfileUpdateFailureAction(error, action.correlationId)))
			)
		)
	);
	@Effect({ dispatch: true })
	sessionInit$ = this.actions$.pipe(
		ofType<SessionInitAction>(SESSION.INIT),
		switchMap(action => iif(() => isServiceEnabled('profile'), of(new ProfileHydrateAction(null, action.correlationId)), EMPTY))
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private profile: ProfileService
	) {}
}
